module.exports = __webpack_public_path__ + "media/kec_index_video.d2cd094e.mp4";